<template>
  <div>
    <portal-target name="dropdown" slim />
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          <div class="bg-shtax-900 md:flex-shrink-0 md:w-56 px-6 py-4 flex items-center justify-between md:justify-center">
            <inertia-link class="text-2xl text-white" href="/">
              e-Faktura
            </inertia-link>
            <dropdown class="md:hidden" placement="bottom-end">
              <svg class="fill-white w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              <div slot="dropdown" class="mt-2 px-8 py-4 shadow-lg bg-shtax-800 rounded">
                <main-menu />
              </div>
            </dropdown>
          </div>
          <div class="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">
            <div class="mt-1 mr-4"> 
              <dropdown class="mr-4" placement="bottom-end" v-if="$page.props.can['see admin module']">
                <div class="flex items-center cursor-pointer select-none group">
                  <div class="text-gray-700 text-base group-hover:text-shtax-600 focus:text-shtax-600 mr-1 whitespace-nowrap">
                    <span>Admin</span><span class="hidden md:inline">istracja</span>
                  </div>
                  <fa icon="chevron-down" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" />
                </div>
                <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('users')" v-if="$page.props.can['see users module']">
                    <fa icon="users" class="w-5 h-5 pt-1 mr-3" fixed-width />Użytkownicy
                  </inertia-link>
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('price_lists')">
                    <fa icon="dollar-sign" class="w-5 h-5 pt-1 mr-3" fixed-width />Cenniki
                  </inertia-link>
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('reports')">
                    <fa icon="clipboard" class="w-5 h-5 pt-1 mr-3" fixed-width />Raporty
                  </inertia-link>

                  <div class="border-b border-shtax-500 my-2"></div>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('roles')">
                    <fa icon="user-tag" class="w-5 h-5 pt-1 mr-3" fixed-width />Role użytkownika
                  </inertia-link>
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('permissions')">
                    <fa icon="user-shield" class="w-5 h-5 pt-1 mr-3" fixed-width />Uprawnienia
                  </inertia-link>
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('factures.cycles')">
                    <fa icon="recycle" class="w-5 h-5 pt-1 mr-3" fixed-width />Cykle fakturowania
                  </inertia-link>
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('kp_rejestr_vat')">
                    <fa icon="building" class="w-5 h-5 pt-1 mr-3" fixed-width />Kaper - Rejestry VAT
                  </inertia-link>

                </div>
              </dropdown>

              <dropdown class="mr-4" placement="bottom-end" v-if="$page.props.can['see configs module']">
                <div class="flex items-center cursor-pointer select-none group">
                  <div class="text-gray-700 text-base group-hover:text-shtax-600 focus:text-shtax-600 mr-1 whitespace-nowrap">
                    <span>Konfiguracje</span>
                  </div>
                  <fa icon="chevron-down" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" />
                </div>
                <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('configs.firm')">
                    <fa icon="building" class="w-5 h-5 pt-1 mr-3" fixed-width />Firma
                  </inertia-link>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('configs.new_facture')">
                    <fa icon="file-invoice" class="w-5 h-5 pt-1 mr-3" fixed-width />Definicji faktury
                  </inertia-link>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('configs.new_facture.position')">
                    <fa icon="file-alt" class="w-5 h-5 pt-1 mr-3" fixed-width />Pozycji definicji faktury
                  </inertia-link>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('factures.config')">
                    <fa icon="file-invoice-dollar" class="w-5 h-5 pt-1 mr-3" fixed-width />Wystawiania dok. handlowych
                  </inertia-link>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('bank_statements.config')">
                    <fa icon="money-check-alt" class="w-5 h-5 pt-1 mr-3" fixed-width />Importu wpłat z wyciągu i rozliczenia
                  </inertia-link>


                </div>
              </dropdown>

              <dropdown class="" placement="bottom-end" v-if="$page.props.can['see mailbox module']">
                <div class="flex items-center cursor-pointer select-none group">
                  <div class="text-gray-700 text-base group-hover:text-shtax-600 focus:text-shtax-600 mr-1 whitespace-nowrap">
                    <span>Poczta</span>
                  </div>
                  <fa icon="chevron-down" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" />
                </div>
                <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('mailbox')">
                    <fa icon="mail-bulk" class="w-5 h-5 pt-1 mr-3" fixed-width />Wysłana
                  </inertia-link>

                  <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('mailbox.drafts')">
                    <span class="fa-stack" style="width: 30px; height: 23px;">
                      <fa :icon="['far','envelope']" fixed-width class="" />
                      <fa icon="exclamation" fixed-width class="fa-stack-1x mt-0 mr-0.5" />
                    </span>Nie wysłana - Kopie robocze
                  </inertia-link>

                  <template v-if="$page.props.can['see mailings module']">
                    
                    <div class="border-b border-shtax-500 my-2"></div>

                    <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('mailbox.mailings')">
                      <fa icon="id-card" class="w-5 h-5 pt-1 mr-3" fixed-width />Newslettery
                    </inertia-link>
                    <template v-if="$page.props.can['add mailings']">
                      <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('mailbox.mailings.create')">
                        <fa icon="plus" class="w-5 h-5 pt-1 mr-3" fixed-width />Nowy newsletter
                      </inertia-link>
                    </template>

                  </template>
                </div>
              </dropdown>
            </div>
            <dropdown class="" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="text-gray-700 text-base group-hover:text-shtax-600 focus:text-shtax-600 mr-1 whitespace-nowrap">
                  <span>{{ $page.props.auth.user.first_name }}</span>
                  <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>
                </div>
                <fa icon="chevron-down" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('users.edit', $page.props.auth.user.id)">
                  <fa icon="id-badge" class="w-5 h-5 pt-1 mr-3" fixed-width />Profil
                </inertia-link>

                <a class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" target="_blank" :href="route('instruction')">
                  <fa icon="tools" class="w-5 h-5 pt-1 mr-3" fixed-width />Instrukcja obsługi
                </a>
                
                <div class="border-b border-shtax-500 my-2"></div>

                <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white w-full text-left" :href="route('logout')" method="delete" as="button">
                  <fa icon="power-off" class="w-5 h-5 pt-1 mr-3" fixed-width />Wyloguj się
                </inertia-link>
              </div>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden md:block bg-shtax-800 flex-shrink-0 w-56 p-10 overflow-y-auto" />
          <div class="md:flex-1 px-4 py-8 md:p-12 md:py-8 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import FlashMessages from '@/ShtaxComponents/FlashMessages'

import MainMenu from '@/ShtaxComponents/MainMenu'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Logo,
    MainMenu,
  },
}
</script>
